export default {"src":"/_next/static/media/DELL.dd314d45.svg","height":18,"width":18};